import { h } from 'preact';
import PropTypes from 'prop-types';

import { IconArrowDown, IconEdit } from '../../1-foundation/icons/icons';
import { modifierList as iconsModifiersList } from '../../1-foundation/icons/props-list';

const DEFAULT_SRC_BADGE = '';

const renderArrowIcon = (iconsColor) => (
  <IconArrowDown
    modifiers={[iconsColor, 'arrow-navigation', 'arrow-down', 'small']}
    classNames="c-tag-select__arrow-icon"
  />
);
const renderEditIcon = (iconsColor) => (
  <IconEdit modifiers={[iconsColor, 'mix', 'edit', 'small']} classNames="c-tag-select__edit-icon" />
);
const renderBadge = (urlLogo) => <img className="c-tag-select__badge" src={urlLogo} />;

const renderBadgeContainer = ({ urlLogo, isDefault, iconsColor }) => {
  if (isDefault) {
    return <div className="c-tag-select__badge-container">{renderEditIcon(iconsColor)}</div>;
  } else {
    return urlLogo ? (
      <div className="c-tag-select__badge-container">{renderBadge(urlLogo)}</div>
    ) : (
      <div className="c-tag-select__badge-container">{renderEditIcon(iconsColor)}</div>
    );
  }
};

const TagSelect = ({ isDefault = true, urlLogo = DEFAULT_SRC_BADGE, name, onClick, iconsColor }) => {
  return (
    <div className="c-tag-select l-spacing-s" onClick={onClick}>
      <div className="c-tag-select__left-box">
        {renderBadgeContainer({ urlLogo, isDefault, iconsColor })}
        <p className="c-tag-select__name">{name}</p>
      </div>
      <button className="c-tag-select__right-box" type="button">
        {renderArrowIcon(iconsColor)}
      </button>
    </div>
  );
};

TagSelect.propTypes = {
  isDefault: PropTypes.bool,
  urlLogo: PropTypes.string,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  iconsColor: PropTypes.oneOf(iconsModifiersList),
};

export default TagSelect;
